type CookiebotConsent =
  | "necessary"
  | "preferences"
  | "statistics"
  | "marketing";

declare global {
  interface Window {
    [index: string]: any;
    Cookiebot?: {
      consent: Record<CookiebotConsent, boolean>;
    };
  }
}
export const useCookiebot = () => {
  return {
    hasConsent: (key: CookiebotConsent) => {
      if (window.Cookiebot?.consent) {
        return window.Cookiebot.consent[key] === true;
      }
      return true;
    },
    getConsents: () => {
      if (window.Cookiebot?.consent) {
        const consent = window.Cookiebot.consent;

        return [
          consent.necessary && "necessary",
          consent.preferences && "preferences",
          consent.statistics && "statistics",
          consent.marketing && "marketing",
        ].truthy() as CookiebotConsent[];
      }
      return [
        "necessary",
        "preferences",
        "statistics",
        "marketing",
      ] as CookiebotConsent[];
    },
  };
};
